import React from 'react';
import { Car, ExternalLink, Sparkles, Award, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

export const VehicleInventory = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-full bg-red-600/20 backdrop-blur-sm">
            <Car className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Unser Fahrzeugbestand
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Entdecken Sie unsere große Auswahl an Neu- und Gebrauchtwagen
          </p>
        </div>

        {/* Hauptanzeige - Über 150 Fahrzeuge */}
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-red-600 to-red-700 rounded-2xl px-12 py-8 shadow-2xl">
            <div className="flex flex-col items-center gap-2">
              <div className="text-7xl font-bold text-white">
                150<span className="text-5xl">+</span>
              </div>
              <div className="text-2xl font-semibold text-white">Fahrzeuge</div>
              <div className="text-base text-red-100">ständig verfügbar</div>
            </div>
          </div>
        </div>

        {/* Feature-Karten ohne Zahlen */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {/* Neufahrzeuge */}
          <Card className="bg-white/10 backdrop-blur-sm border-0 p-8 text-center hover:bg-white/15 transition-all duration-300 hover:scale-105 rounded-xl">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-red-500 to-red-600 shadow-lg">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
            <div className="text-xl font-bold text-white mb-2">Neufahrzeuge</div>
            <div className="text-sm text-gray-300">Aktuelle Modelle von Nissan und Mazda</div>
          </Card>

          {/* Gebrauchtfahrzeuge */}
          <Card className="bg-white/10 backdrop-blur-sm border-0 p-8 text-center hover:bg-white/15 transition-all duration-300 hover:scale-105 rounded-xl">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-red-500 to-red-600 shadow-lg">
              <Award className="w-8 h-8 text-white" />
            </div>
            <div className="text-xl font-bold text-white mb-2">Gebrauchtfahrzeuge</div>
            <div className="text-sm text-gray-300">Geprüfte Qualität zum fairen Preis</div>
          </Card>

          {/* Händlerzulassungen */}
          <Card className="bg-white/10 backdrop-blur-sm border-0 p-8 text-center hover:bg-white/15 transition-all duration-300 hover:scale-105 rounded-xl">
            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-red-500 to-red-600 shadow-lg">
              <Clock className="w-8 h-8 text-white" />
            </div>
            <div className="text-xl font-bold text-white mb-2">Händlerzulassungen</div>
            <div className="text-sm text-gray-300">Sofort verfügbar für Sie</div>
          </Card>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="/fahrzeugbestand.html"
            className="inline-block"
          >
            <Button
              className="bg-red-600 hover:bg-red-700 text-white px-10 py-6 text-lg font-semibold rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-red-600/50 group"
            >
              <span className="flex items-center gap-3">
                Zum Fahrzeugbestand
                <ExternalLink className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </Button>
          </a>

          <a
            href="/fahrzeugbestand.html"
            className="inline-block"
          >
            <Button
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-10 py-6 text-lg font-semibold rounded-lg shadow-2xl transition-all duration-300 hover:scale-105 backdrop-blur-sm bg-white/10"
            >
              Fahrzeuge durchsuchen
            </Button>
          </a>
        </div>

        {/* Info Text */}
        <div className="text-center mt-8">
          <p className="text-gray-400 text-sm mb-2">
            Unser Bestand wird täglich aktualisiert • Alle Fahrzeuge sofort verfügbar
          </p>
          <p className="text-red-400 font-semibold">
            Finanzierung bereits ab 99 €/Monat möglich
          </p>
        </div>
      </div>
    </section>
  );
};
